import { api } from '../api';

// `typeID` agora carrega a string do papel (role), não mais um UUID de perfil.
// O endpoint dedicado altera SOMENTE o papel do usuário. Ver backend
// UpdateUsersRoleService / PUT /users/roles.
export const updateUserProfile = async (
  keys: { userID: string; typeID: string }[],
): Promise<void> => {
  await api.put('/users/roles', {
    keys: keys.map(({ userID, typeID }) => ({ userID, role: typeID })),
  });
};
